import React, { useContext } from 'react'
import { components, constants, useTranslation } from 'cng-web-lib'
import StatusNotificationFormProperties from './StatusNotificationFormProperties'
import Box from '@material-ui/core/Box'
import { AesTranslationContext } from '../contexts/AESTranslationContext'

const {
  button: { CngButton },
  form: { CngForm },
  CngDialog
} = components

const { FormState } = constants

function StatusNotificationDialog(props) {
  const {
    open,
    onAddStatusNotification,
    onClose,
    onEditStatusNotification,
    headerId,
    showNotification,
    statusNotification,
    type
  } = props

  const { getTranslatedText } = useContext(AesTranslationContext)

  const { initialValues, makeValidationSchema } = StatusNotificationFormProperties.formikProps
  return (
    <CngDialog
      dialogContent={
        <CngForm
          fieldLevel='form'
          formikProps={{
            initialValues: {
              ...(statusNotification || initialValues),
              headerId: headerId
            },
            makeValidationSchema: makeValidationSchema,
            onSubmit: (data) => {
              console.log("submit")
              if (type === 'EDIT') {
                onEditStatusNotification(data)
              } else {
                delete data.id

                onAddStatusNotification(data)
              }
            }
          }}
          formState={FormState.COMPLETED}
          renderBodySection={(labelMap, shouldHideMap) => (
            <StatusNotificationFormProperties.Fields
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
            />
          )}
          renderButtonSection={() => (
            <Box display='flex' justifyContent='flex-end'>
              <CngButton color='primary' size='medium' type='submit'>
                {getTranslatedText('AES', 'saveButton')}
              </CngButton>
            </Box>
          )}
        />
      }
      dialogTitle={getTranslatedText('AES', 'snDetails')}
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      fullWidth
      maxWidth='md'
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          onClose()
        }
      }}
      open={open}
      shouldShowCloseButton
    />
  )
}

export default StatusNotificationDialog
